import styled from 'styled-components';

import { media } from 'utils/detection';

export default styled.div`
  position: relative;
  background-color: #d7fffc;
  cursor: grab;
`;
